// extracted by mini-css-extract-plugin
export default {"wrapper__info":"DetailsHeader_wrapper__info__ifAxw","wrapper":"DetailsHeader_wrapper__q-jaq","avatar":"DetailsHeader_avatar__nSL1D"};